import { createReducer, on } from '@ngrx/store';
import { produce } from 'immer';
import {
  setDebtsId,
  setDocument,
  setDocumentType,
  setHasCreditFee,
  setPartnerId,
  setPurchaseCallbackUrl,
  setPurchaseOrder,
  setPurchaseOrderAmount,
  setPurchaseOrderId,
  setPurchasePaymentConditions,
  setTransaction,
} from './purchase.actions';
import { purchaseInitialState } from './purchase.types';

export const purchaseReducer = createReducer(
  purchaseInitialState,

  on(setPurchaseOrder, (state, order) =>
    produce(state, (draft) => {
      draft.order = order.order;
    })
  ),

  on(setDebtsId, (state, order) =>
    produce(state, (draft) => {
      draft.order.debtsId = order.debtId;
    })
  ),

  on(setPurchaseOrderId, (state, order) =>
    produce(state, (draft) => {
      draft.order.id = order.id;
    })
  ),

  on(setPurchaseOrderAmount, (state, order) =>
    produce(state, (draft) => {
      draft.order.amount = order.amount;
    })
  ),

  on(setHasCreditFee, (state, props) =>
    produce(state, (draft) => {
      draft.hasCreditFee = props.hasCreditFee;
    })
  ),

  on(setTransaction, (state, order) =>
    produce(state, (draft) => {
      draft.transaction = order.transaction;
    })
  ),

  on(setDocument, (state, order) =>
    produce(state, (draft) => {
      draft.document = order.document;
    })
  ),

  on(setDocumentType, (state, order) =>
    produce(state, (draft) => {
      draft.documentType = order.documentType;
    })
  ),

  on(setPartnerId, (state, order) =>
    produce(state, (draft) => {
      draft.partnerId = order.partnerId;
    })
  ),

  on(setPurchasePaymentConditions, (state, order) =>
    produce(state, (draft) => {
      draft.paymentCondition = order.paymentCondition;
    })
  ),

  on(setPurchaseCallbackUrl, (state, order) =>
    produce(state, (draft) => {
      draft.callbackUrl = order.callbackUrl;
    })
  )
);
